var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"card ads"},[_c('div',{staticClass:"description"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@/assets/images/cat.png"),"alt":"cat"}})]),_c('button',{staticClass:"btn"},[_vm._v(_vm._s(_vm.btn_text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }